import Header from '../VcHeaderComponent'
import SideMenu from '../SideMenu'
  
/**
 * The Layout function is a React component that renders a layout with a top navigation bar, a narrow
 * sidebar, and a main area for content.
 * @returns the `children` prop, which means it will render the content that is passed as a child to
 * the `Layout` component.
 */
export default function Layout({children}) {
  return children;
 
  return (
    <>
      <div className="bg-gray-100">
        <div className="min-h-screen flex flex-col">
            {/* Top nav*/}
            <Header />
            {/* Bottom section */}
            <div className=" min-h-0 overflow-hidden">
            {/* Narrow sidebar*/}
            <div className="hidden md:block	">
                <SideMenu  />
            </div>
            
            {/* Main area */}
            <main className="lg:ml-[5rem] md:ml-[5.25rem]">
               {children}
            </main>
            
            </div>
        </div>
      </div>
    </>
  )
}